function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRefCallback } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import React from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Button } from '../../../components/button/Button';
export function CompareRangeDateFooter(props) {
  var extra = props.extra,
      className = props.className,
      _props$disableOk = props.disableOk,
      disableOk = _props$disableOk === void 0 ? true : _props$disableOk,
      onOk = props.onOk,
      onCancel = props.onCancel,
      others = _objectWithoutProperties(props, ["extra", "className", "disableOk", "onOk", "onCancel"]);

  var onOkCallback = useRefCallback(function () {
    disableOk && onOk && onOk();
  });
  var onCancelCallback = useRefCallback(onCancel);
  var cls = classnames(usePrefixCls('compare-range-date-footer'), className);
  var extraCls = usePrefixCls('compare-range-date-footer-extra');
  var opCls = usePrefixCls('compare-range-date-footer-op');
  var locale = useLocale('date-picker.cancel');
  var apply = useLocale('date-picker.apply');
  return React.createElement("div", Object.assign({}, others, {
    className: cls
  }), React.createElement("div", {
    className: extraCls
  }, extra), React.createElement("div", {
    className: opCls
  }, React.createElement(Button, {
    size: 'sm',
    type: 'default',
    onClick: onCancelCallback
  }, locale), React.createElement(Button, {
    disabled: !disableOk,
    size: 'sm',
    type: 'primary',
    onClick: onOkCallback
  }, apply)));
}